<template>
  <div>
    <v-card class="detail-card d-flex flex-column" style="height:100vh;">
      <!-- Toolbar -->
      <div class="dlg-toolbar flex-shrink-0 d-flex align-center px-3">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-avatar color="success" size="36" class="ml-2 mr-3">
          <v-icon small color="white">fas fa-rss</v-icon>
        </v-avatar>
        <div>
          <div class="subtitle-1 font-weight-black white--text lh-1">Sincronización Softnet</div>
          <div v-if="sales_note" class="caption success--text lh-1 mt-1">
            OT #{{ sales_note.work_order }} · Crear Documento
          </div>
        </div>
        <v-spacer />
        <v-btn icon dark @click="fetchSoftnetData" :loading="loading" class="mr-2">
          <v-icon small>fas fa-sync-alt</v-icon>
        </v-btn>
      </div>

      <!-- Body -->
      <div class="detail-body flex-grow-1 overflow-y-auto pa-6">
        <!-- Loading -->
        <div v-if="loading" class="d-flex flex-column align-center justify-center" style="min-height:300px;">
          <v-progress-circular indeterminate color="success" size="52" />
          <div class="caption grey--text mt-5">Cargando datos desde Softnet...</div>
        </div>

        <ValidationObserver v-slot="{handleSubmit}" v-else>
          <v-form @submit.prevent="handleSubmit(confirm)">
            <v-row>
              <!-- Columna izquierda: datos -->
              <v-col cols="12" md="3">
                <v-card outlined class="modern-card mb-5 pa-5">
                  <div class="section-title mb-4">
                    <v-icon x-small color="success" class="mr-2">fas fa-user</v-icon>
                    RECEPTOR
                  </div>
                  
                  <div class="field-label">RUT</div>
                  <v-text-field
                    :value="customer_data ? customer_data.rut : ''"
                    outlined dense class="modern-input mb-3"
                    readonly hide-details
                  />

                  <div class="field-label">Razón Social</div>
                  <v-text-field
                    :value="customer_data ? customer_data.nombre_rz : ''"
                    outlined dense class="modern-input mb-3"
                    readonly hide-details
                  />

                  <div class="field-label">Giro</div>
                  <v-text-field
                    :value="customer_data ? customer_data.giro : ''"
                    outlined dense class="modern-input mb-3"
                    readonly hide-details
                  />

                  <div class="field-label">Dirección</div>
                  <v-select
                    v-model="direccion"
                    :items="customer_data ? customer_data.direccion : []"
                    item-text="direccion"
                    item-value="id"
                    outlined dense class="modern-input"
                    hide-details
                  />
                </v-card>

                <v-card outlined class="modern-card pa-5 mb-5">
                  <div class="section-title mb-4">
                    <v-icon x-small color="success" class="mr-2">fas fa-sliders-h</v-icon>
                    PARÁMETROS
                  </div>

                  <div class="field-label">Vendedor</div>
                  <v-text-field
                    :value="seller_name"
                    outlined dense class="modern-input mb-3"
                    readonly hide-details
                  />

                  <div class="field-label">Forma de Pago</div>
                  <v-select
                    v-model="forma_pago"
                    :items="formas_pago"
                    item-text="nombre"
                    item-value="id"
                    outlined dense class="modern-input mb-3"
                    hide-details
                  />

                  <div class="field-label">Área de Negocio</div>
                  <v-select
                    v-model="area_negocio"
                    :items="areas_negocio"
                    item-text="nombre"
                    item-value="id"
                    outlined dense class="modern-input"
                    hide-details
                  />
                </v-card>
              </v-col>

              <!-- Columna derecha: lineas -->
              <v-col cols="12" md="9">
                <v-card outlined class="modern-card mb-5">
                  <div class="px-6 pt-5 pb-2">
                    <div class="section-title mb-4 d-flex justify-space-between">
                      <div>
                        <v-icon x-small color="success" class="mr-2">fas fa-list</v-icon>
                        LÍNEAS DE DETALLE
                      </div>
                    </div>
                    <table class="detail-table">
                      <thead>
                        <tr>
                          <th class="text-left" style="width:10%">Código</th>
                          <th class="text-left" style="width:40%">Descripción</th>
                          <th class="text-center" style="width:15%">Cantidad</th>
                          <th class="text-right" style="width:20%">Precio Unit.</th>
                          <th class="text-right" style="width:15%">Total</th>
                          <th class="text-center" style="width:5%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, i) in productos"
                          :key="i"
                          :class="i % 2 === 0 ? 'row-even' : 'row-odd'"
                        >
                          <td class="td-sku">{{ item.sku || '—' }}</td>
                          <td class="td-name font-weight-bold">{{ item.name }}</td>
                          <td class="text-center">
                            <ValidationProvider name="qty" rules="required" v-slot="{ errors }">
                              <v-text-field
                                type="number"
                                v-model="item.qty"
                                :min="1"
                                :error-messages="errors"
                                :hide-details="errors.length < 1"
                                outlined dense class="modern-input"
                              />
                            </ValidationProvider>
                          </td>
                          <td class="text-right">
                            <ValidationProvider name="price" rules="required" v-slot="{ errors }">
                              <v-text-field
                                type="number"
                                v-model="item.price"
                                :min="0"
                                :error-messages="errors"
                                :hide-details="errors.length < 1"
                                outlined dense class="modern-input text-right"
                              />
                            </ValidationProvider>
                          </td>
                          <td class="text-right td-total">{{ (item.price * item.qty) | moneda }}</td>
                          <td class="text-center">
                            <v-btn icon small color="error" @click.stop="removeItem(item)">
                              <v-icon small>fas fa-trash</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <tr v-if="!productos || productos.length === 0">
                          <td colspan="6" class="text-center grey--text caption py-6">Sin líneas de detalle</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Totals -->
                  <div class="d-flex justify-end pa-6 pt-3">
                    <div class="totals-box">
                      <div class="totals-row">
                        <span class="totals-label">Neto</span>
                        <span class="totals-amount">{{ neto | moneda }}</span>
                      </div>
                      <div class="totals-row">
                        <span class="totals-label d-flex align-center">
                          IVA (
                          <ValidationProvider name="IVA" rules="required" v-slot="{ errors }">
                            <input 
                              type="number" 
                              v-model="iva" 
                              style="width: 30px; border-bottom: 1px solid #ccc; text-align: center;" 
                              max="100" min="0" class="mx-1"
                            >
                          </ValidationProvider>
                          %)
                        </span>
                        <span class="totals-amount">{{ neto * (iva / 100) | moneda }}</span>
                      </div>
                      <v-divider class="my-2" />
                      <div class="totals-row totals-grand">
                        <span class="totals-label-grand">TOTAL</span>
                        <span class="totals-amount-grand">{{ neto * (1 + iva / 100) | moneda }}</span>
                      </div>
                    </div>
                  </div>
                </v-card>

                <div class="d-flex justify-end mt-4">
                  <v-btn
                    color="success"
                    class="font-weight-black px-6"
                    type="submit"
                    :loading="sending"
                    :disabled="productos.length === 0"
                    large
                  >
                    <v-icon left small>fas fa-paper-plane</v-icon>
                    Sincronizar OT con Softnet
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </div>

      <confirm 
        v-model="showConfirm" 
        :message="sales_note ? `Se creará un nuevo documento en Softnet vinculado a la OT ${sales_note.work_order}` : '-'" 
        @ok="sendData"
        @cancel="showConfirm=false" />
    </v-card>
  </div>
</template>
<script>
import { getFullData,createDocument } from "@/api/softnet";
import notifications from "../../utils/notifications";
import numeral from "numeral";

export default{
  name:'CreateDocument',
  props:['sales_note_id'],
  data(){
    return{
      loading:false,
      showConfirm:false,
      sending:false,
      customer_data:{},
      sales_note:{},
      formas_pago:[],
      forma_pago:'',
      direccion:'',
      areas_negocio:[],
      area_negocio:'',
      seller_name:'',
      productos:[],
      exento:0,
      iva:parseInt(this.$store.getters.getCompany.tax),
      headers:[
        {
          text: 'Código',
          align: 'start',
          sortable: false,
          value: 'sku',
          show:false,
          class:'table-header2'
        },
        {
          text: 'Nombre',
          align: 'start',
          sortable: false,
          value: 'name',
          show:true,
          class:'table-header2'
        },
        {
          text: 'Cantidad',
          align: 'end',
          sortable: false,
          value: 'qty',
          width:'10%',
          show:true,
          class:'table-header2'
        },
        {
          text: 'Precio Unit.',
          align: 'end',
          sortable: false,
          value: 'price',
          show:true,
          width:'12%',
          class:'table-header2'
        },
        {
          text: 'Total',
          align: 'end',
          sortable: false,
          value: 'total',
          show:true,
          class:'table-header2'
        },
        {
          text: '',
          align: 'end',
          sortable: false,
          value: 'actions',
          show:true,
          class:'table-header2'
        },
        ],

    }
  },
  methods:{
    removeItem(item){ 
      this.productos.splice(this.productos.indexOf(item),1)  
    },
    confirm(){
      this.showConfirm=true
    },
    async fetchSoftnetData(){
      this.loading = true;
      await getFullData(this.sales_note_id).then(response => {
        console.log(response)
        const {customer_data, sales_note,forma_pago,area_negocio} = response;
        this.customer_data=customer_data;
        this.direccion=customer_data.direccion[0].id;
        this.sales_note=sales_note;
        this.formas_pago=forma_pago;
        this.forma_pago=forma_pago[0].id;
        this.areas_negocio=area_negocio;
        this.area_negocio=area_negocio[0].id;
        this.seller_name=sales_note.sales_note_customer.seller.first_name+' '+sales_note.sales_note_customer.seller.last_name;
        const discountFactor=1-parseFloat(sales_note.totals.discount)/100;
        this.productos=sales_note.details.products.map(producto => {
          producto.price=parseFloat(producto.qty)!=0?parseFloat(producto.totalPrice/producto.qty)*discountFactor:0;
          producto.qty=parseFloat(producto.qty);
          
          
          return producto;
          });
        this.loading = false;
      })
      .catch(error => {
        notifications.showError(error);
        this.loading = false;
      })
    },
    async sendData(){
      this.sending=true
      const data={
        workorder_id:this.sales_note.work_order,
        area_negocio:this.area_negocio,
        condicion_pago:this.forma_pago,
        direccion:this.direccion,
        neto:this.neto,
        exento:this.exento,
        descuento:0,
        total:this.neto+this.exento,
        observacion:`COT ${this.sales_note.id} - OT ${this.sales_note.work_order}`,
        detalle:this.productos.map(p=>{
          const qty = p.qty
          const price = p.price
          return {
            Codigo:p.sku,
            Cantidad:p.qty,
            Precio:p.price,
            Descuento:0,
            Afecto:true
          }
        }),
      }

      await createDocument(data).then(response => {
        const {mensaje,folio} = response[0];
        notifications.showSuccess(`${mensaje} folio: ${folio}`);
        this.sending=false
        this.showConfirm=false
        this.$emit('close')
      })
      .catch(e=>{
        notifications.showError(e);
        this.sending=false
        this.showConfirm=false
      })
    }
  },
  computed:{
    neto(){
      return this.productos.reduce((acc,val)=>{return acc + parseFloat(val.qty)*parseFloat(val.price);},0)
    },
    company(){
      return this.$store.getters.getCompany
    },
  },
  watch:{
    sales_note_id(newValue){
      console.log(newValue)
      this.fetchSoftnetData();
    }
  },
  async created(){
    this.fetchSoftnetData();
  }
}
</script>

<style scoped>
.dlg-toolbar { height: 64px; min-height: 64px; max-height: 64px; background-color: #1A1F2E; }
.detail-card { background-color: #f4f7f9; border-radius: 0; }
.detail-body { background-color: #f4f7f9; }

.modern-card {
  border-radius: 10px !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  background: white !important;
}

.modern-input {
  border-radius: 8px !important;
}

.section-title {
  font-size: 0.68rem;
  font-weight: 900;
  letter-spacing: 2px;
  color: #4CAF50;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.field-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #546e7a;
  margin-bottom: 4px;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.83rem;
  margin-bottom: 4px;
}
.detail-table thead tr { background: #f0f4f7; }
.detail-table th {
  padding: 8px 10px;
  font-size: 0.68rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #546e7a;
  border-bottom: 2px solid #e0e7ef;
}
.detail-table td { padding: 9px 10px; border-bottom: 1px solid #f0f4f7; vertical-align: middle; }
.row-even { background: white; }
.row-odd  { background: #fafbfc; }

.totals-box { min-width: 260px; }
.totals-row { display: flex; justify-content: space-between; align-items: center; padding: 4px 0; }
.totals-label { font-size: 0.82rem; color: #607d8b; font-weight: 600; }
.totals-amount { font-size: 0.9rem; font-weight: 700; color: #1A1F2E; font-variant-numeric: tabular-nums; }
.totals-grand { padding-top: 6px; }
.totals-label-grand { font-size: 0.9rem; font-weight: 900; color: #1A1F2E; letter-spacing: 1px; text-transform: uppercase; }
.totals-amount-grand { font-size: 1.5rem; font-weight: 900; color: #1A1F2E; font-variant-numeric: tabular-nums; letter-spacing: -0.5px; }

.lh-1 { line-height: 1 !important; }
</style>